import { GetMainSectionFn } from '../custom-topic-routes'
import { billboardLeaderboardMrec } from '../../ad-units'
import { layout } from '../../../App.routing'
import { stateElection2021Segment } from '../../features/state-election-2021'

export const getStateElection2021RouteInfo: GetMainSectionFn = () => {
    return [
        layout.nestedComposition({
            type: 'thor',
            props: {
                hasBackgroundFill: false,
                containerWidth: '100%',
                verticalGutters: false,
                horizontalGutters: true,
                stateElectionCollection: true,
                showHeading: false,
            },
            contentAreas: {
                main: [
                    ...stateElection2021Segment({
                        feature: 'state-election-collection-topic-landing',
                        showHeading: false,
                    }),
                ],
            },
        }),
        ...billboardLeaderboardMrec('one'),
        layout.component({
            type: 'lima',
            props: {
                verticalSpacing: 'xl',
                fontScale: 1.2,
                fixedRatios: ['16:9'],
                hasBackground: true,
                teaserMode: 'hidden',
                initialColumns: 1,
                intermediateColumns: 2,
                finalColumns: 4,
                loadMoreEnabled: true,
                cardOrientation: { type: 'Landscape-Portrait' },

                sectionHeader: {
                    heading: 'Latest',
                    section: 'sport',
                },
                dataDefinitionArgs: {
                    type: 'listing',
                    topics: ['politics/state-election-2021'],
                    includeSubTopics: false,
                    paging: {
                        page: 1,
                        pageSize: 16,
                    },
                },
            },
        }),
    ]
}
